import React from "react";
import InfoPopoverButton from "../../InfoPopoverButton";

const CHART_HEIGHT = 400;

const ChartCard = ({ chart, summary, children }) => {
  return (
    <div className="w-100 mb-2 mb-md-4">
      <div className="card p-2 p-md-4">
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3">
          <div className="d-flex align-items-center">
            <h5 className="mb-0">{chart.title}</h5>
            <InfoPopoverButton
              id={chart.type}
              title={chart.title}
              description={chart.description}
            />
          </div>
          {summary && (
            <div className="font-weight-bold text-nowrap mt-2 mt-sm-0">
              {summary}
            </div>
          )}
        </div>
        <div style={{ height: `${CHART_HEIGHT}px` }}>{children}</div>
      </div>
    </div>
  );
};

export default ChartCard;
